import React from 'react';
import { Stack, Typography } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';

type Props = {
  requirements: string[];
};

export const PreferredAnswerRequirementsList: React.FC<Props> = ({
  requirements
}) => {
  return (
    <>
      {requirements.map((requirement, index) => (
        <Stack key={`${index}`} direction="row" gap={1} alignItems="center">
          <DoneIcon
            fontSize="small"
            sx={{
              color: 'successV2.main'
            }}
          />
          <Typography>{requirement}</Typography>
        </Stack>
      ))}
    </>
  );
};
